
export class Note {
    RecId: string;
    Seq = 0;
    Selected: string;
    TextArea: string;

    constructor(data: any) {
        this.RecId = data.id;

        if (data.TextArea) {
            this.Seq = data.Seq;
            this.Selected = data.Selected;
            this.TextArea = data.TextArea;
        }
    }
}
